import { z } from 'zod';

export const LotteryPrizeSchema = z.object({
  id: z.string(),
  version: z.literal(1),
  displayName: z.string(),
  description: z.string(),
  quantity: z.number().min(1),
});

export type LotteryPrizeType = z.infer<typeof LotteryPrizeSchema>;

export const LotteryWinnerSchema = z.object({
  priceId: z.string(),
  lotteryEntryId: z.string(),
});

export type LotteryWinnerType = z.infer<typeof LotteryWinnerSchema>;

// Views used by web app data layer when aggregating lottery results
export interface LotteryPrizeView {
  id: string;
  name: string;
  description: string | null;
  imageUrl: string | null;
}

export interface LotteryEntryRowView {
  id: string;
  phone: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  createdAt: string;
}

export interface LotteryAggregatedEntry {
  winner: LotteryWinnerType;
  prize: LotteryPrizeView | null;
  entry: LotteryEntryRowView;
}
